import { useCallback, useEffect, useState } from 'react';
import { clearAdminSecurityLogs, getAdminSecurity, type SecurityOverview } from '../api/admin';

export function useAdminSecurity(params?: { from?: string; to?: string }) {
  const [data, setData]       = useState<SecurityOverview | null>(null);
  const [loading, setLoading] = useState(true);
  const [clearing, setClearing] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getAdminSecurity(params);
      setData(res.data.data);
    } finally {
      setLoading(false);
    }
  }, [params?.from, params?.to]);

  useEffect(() => {
    refresh().catch(() => setData(null));
  }, [refresh]);

  const clearLogs = useCallback(async () => {
    setClearing(true);
    try {
      const res = await clearAdminSecurityLogs();
      return res.data.data;
    } finally {
      setClearing(false);
    }
  }, []);

  return { data, loading, clearing, refresh, clearLogs };
}
